
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 5.292 5.292","height":"20","width":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.081 0v2.082H0V3.21h2.081v2.082h1.13V3.21h2.08V2.082h-2.08V0z","fill":"#fff"}})])
          )
        }
      }
    